export default () => ({
    info: {},
    settings: {},
    loading: false,
    error: false,
    breadcrumbs:[]
});
